import { CONNECTION } from "../../config/Connections";
import { CONFIG_ } from "../../config/Config";
import { successnotify } from "../../components/ToasNotif/Toast";
import { __openModal } from "../Modal";

var get = "/typeuser";
var post = "/typeuser";
export const actGetDataTypeuser = () => {
  return dispatch => {
    let config = CONFIG_({ url: get, method: "GET" });
    dispatch({ type: "LOADING_TYPEUSER_TYPEUSER" });
    CONNECTION(config)
      .then(response => {
        const { status, data } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_TYPEUSER_TYPEUSER",
            message: "Success get data",
            data: data,
            code: status
          });
        }
        return dispatch({ type: "ERROR_TYPEUSER_TYPEUSER", message: "failed" });
      })
      .catch(response => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEUSER_TYPEUSER",
          message: "Network error.."
        });
      });
  };
};

export const actPostDataTypeuser = params => {
  return dispatch => {
    let config = CONFIG_({ url: post, data: params, method: "POST" });
    dispatch({ type: "LOADING_TYPEUSER_TYPEUSER" });
    CONNECTION(config)
      .then(response => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type user has been created");
          dispatch(__openModal({ modal: "MODAL_ADD_TYPEUSER", open: false }));
          return dispatch(actGetDataTypeuser());
        }
        return dispatch({ type: "ERROR_TYPEUSER_TYPEUSER", message: "failed" });
      })
      .catch(response => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEUSER_TYPEUSER",
          message: "Network error.."
        });
      });
  };
};

export const actUpdateDataTypeuser = params => {
  return dispatch => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, data: params, method: "PUT" });
    dispatch({ type: "LOADING_TYPEUSER_TYPEUSER" });
    CONNECTION(config)
      .then(response => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type user has been updated");
          dispatch(__openModal({ modal: "MODAL_EDIT_TYPEUSER", open: false }));
          return dispatch(actGetDataTypeuser());
        }
        return dispatch({ type: "ERROR_TYPEUSER_TYPEUSER", message: "failed" });
      })
      .catch(response => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEUSER_TYPEUSER",
          message: "Network error.."
        });
      });
  };
};

export const actDetailDataTypeuser = params => {
  return dispatch => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "GET" });
    dispatch({ type: "LOADING_TYPEUSER_TYPEUSER" });
    CONNECTION(config)
      .then(response => {
        const { status } = response;
        if (status === 200) {
          return dispatch({
            type: "SUCCESS_TYPEUSER_TYPEUSER",
            message: "Success get data"
          });
        }
        return dispatch({ type: "ERROR_TYPEUSER_TYPEUSER", message: "failed" });
      })
      .catch(response => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEUSER_TYPEUSER",
          message: "Network error.."
        });
      });
  };
};

export const actDeleteDataTypeuser = params => {
  return dispatch => {
    const { id } = params;
    let config = CONFIG_({ url: post + "/" + id, method: "DELETE" });
    dispatch({ type: "LOADING_TYPEUSER_TYPEUSER" });
    CONNECTION(config)
      .then(response => {
        const { status } = response;
        if (status === 200) {
          successnotify("Type user has been deleted");
          return dispatch(actGetDataTypeuser());
        }
        return dispatch({ type: "ERROR_TYPEUSER_TYPEUSER", message: "failed" });
      })
      .catch(response => {
        console.log(response);
        return dispatch({
          type: "ERROR_TYPEUSER_TYPEUSER",
          message: "Network error.."
        });
      });
  };
};
